import { render, staticRenderFns } from "./IotModelPointsForm.vue?vue&type=template&id=1bfefb3c&"
import script from "./IotModelPointsForm.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports